import { nonSupportedViewsForViewState } from "../../../constants/OtherKeys.jsx";
import ViewSharedUtil from "../ViewSharedUtil.js";

// TODO: This storage responsible for only dismissing the view only and not working like other storages to save anything anywhere
class ViewViewStateStorage {

  constructor(keyName) {
    this.keyName = keyName;
  }

  saveStateMutation(processedState, viewManager, viewType) {
    const selectedView = viewManager.renderState.selectedView;
    const viewState = selectedView.isDefaultView ? selectedView.viewState.customViewState : selectedView.viewState;
    if (!nonSupportedViewsForViewState.includes(viewType)) {
      if (ViewSharedUtil.isStoreStateChanged(viewState[viewType], processedState[this.keyName])) {
        // we need to keep the current state of view on dismissing to the default view
        const toApplyState = Object.keys(viewManager.pageViewsRef).reduce((accum, viewTypeKey) => {
          return { ...accum, [viewTypeKey]: viewManager.pageViewsRef[viewTypeKey].state };
        }, {});
        viewManager.setPIITSChanges({...(selectedView.hasPIITS ?? {}), [viewType]: toApplyState[viewType]});
        console.log("___PIITS CREATED___");
      } else {
        viewManager.clearPIITSChangesByViewType(viewType);
      }
    }
  }
}

export default ViewViewStateStorage;
